export default class {
    constructor() {
        
        this.el = document.getElementById('CloudflarePlayer');
        
        if (!this.el) 
            return;

        this.player = null;
        this.playerReady = false;
        this.playthroughCount = 0;
        
        this.stopCount = this.el.dataset.videoloopcount;
        if (this.stopCount < 1)
            this.stopCount = 99999;

        this.isPaused = true;
        this.autoplayPaused = false;
        this._intervalId = null; // track interval
        this._intersectionObserver = null;

        // Load SDK or init immediately
        if (window.Stream) {
            this.initPlayer();
        } else {
            $.getScript('https://embed.videodelivery.net/embed/sdk.latest.js')
                .done(() => this.initPlayer())
                .fail((err) => console.error('Failed to load Stream SDK', err));
        }

        // Observe DOM changes (iframe reload/replacement)
        this.observeElement();
    }

    initPlayer() {
        // Clean up previous interval
        if (this._intervalId) {
            clearInterval(this._intervalId);
            this._intervalId = null;
        }

        this.playerReady = false;
        this.player = Stream(this.el);
        this.player.muted = true; // ensure autoplay works

        this.player.addEventListener('loadedmetadata', () => {
            this.playerReady = true;
            this.normalizeUI();
            this.bindUI();

            // Only attach visibility observer after player is ready
            if (!this._intersectionObserver) {
                this.observeVisibility();
            }

            // Start interval to track loop/playthrough
            this._intervalId = setInterval(() => this.checkPlaythrough(), 200);
        });
    }

    checkPlaythrough() {
        if (!this.playerReady) 
            return;

        const t = this.player.currentTime;
        const d = this.player.duration;

        if (t < this._prevTime && this._prevTime > 0.1) {
            this.playthroughCount++;
            if (this.playthroughCount >= this.stopCount) {
                this.safePause();
            }
        }
        this._prevTime = t;
    }

    observeElement() {
        if (this._mutationObserver) 
            return;

        this._mutationObserver = new MutationObserver(() => {
            const el = document.getElementById('CloudflarePlayer');
            if (el && el !== this.el) {
                this.el = el;
                this.initPlayer();
            }
        });

        this._mutationObserver.observe(document.body, { childList: true, subtree: true });
    }

    observeVisibility() {
        this._intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!this.playerReady) 
                    return;

                if (entry.isIntersecting) {
                    if (this.autoplayPaused && this.playthroughCount < this.stopCount) {
                        this.safePlay();
                        this.autoplayPaused = false;
                    }
                } else {
                    if (!this.isPaused) {
                        this.safePause();
                        this.autoplayPaused = true;
                    }
                }
            });
        }, { threshold: 0.1 });

        this._intersectionObserver.observe(this.el);
    }

    updateButtonUI() {
        const btn = $('.hero-video-pauseplay');
        if (this.isPaused) {
            btn.addClass('paused');
            btn.attr('aria-label', 'Play background video');
        } else {
            btn.removeClass('paused');
            btn.attr('aria-label', 'Pause background video');
        }
    }

    safePlay() {
        if (!this.playerReady || !this.isPaused) 
            return;

        this.player.play().catch(() => {
            this.player.muted = true;
            this.player.play();
        });

        this.isPaused = false;
        this.updateButtonUI();
    }

    safePause() {
        if (!this.playerReady || this.isPaused) 
            return;

        this.player.pause();
        this.isPaused = true;
        this.updateButtonUI();
    }

    normalizeUI() {
        this.isPaused = false;
        this.updateButtonUI();
    }

    bindUI() {
        $('.hero-video-pauseplay').off('click').on('click', () => {
            this.playthroughCount = 0;
            if (this.isPaused) {
                this.safePlay();
            } else {
                this.safePause();
            }
        });
    }
}
